import { render, staticRenderFns } from "./infiniteIcon.vue?vue&type=template&id=342a3ba8"
import script from "./infiniteIcon.vue?vue&type=script&lang=js"
export * from "./infiniteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports